import React from 'react';

export const MessageIcon = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_24485_9287)">
      <path
        d="M0 0.875L14 0.875L14 11.375H7.36225L5.25 13.4872L3.13775 11.375H0L0 0.875ZM5.25 6.125C5.25 5.89294 5.15781 5.67038 4.99372 5.50628C4.82962 5.34219 4.60706 5.25 4.375 5.25C4.14294 5.25 3.92038 5.34219 3.75628 5.50628C3.59219 5.67038 3.5 5.89294 3.5 6.125C3.5 6.35706 3.59219 6.57962 3.75628 6.74372C3.92038 6.90781 4.14294 7 4.375 7C4.60706 7 4.82962 6.90781 4.99372 6.74372C5.15781 6.57962 5.25 6.35706 5.25 6.125ZM7.875 6.125C7.875 5.89294 7.78281 5.67038 7.61872 5.50628C7.45462 5.34219 7.23206 5.25 7 5.25C6.76794 5.25 6.54538 5.34219 6.38128 5.50628C6.21719 5.67038 6.125 5.89294 6.125 6.125C6.125 6.35706 6.21719 6.57962 6.38128 6.74372C6.54538 6.90781 6.76794 7 7 7C7.23206 7 7.45462 6.90781 7.61872 6.74372C7.78281 6.57962 7.875 6.35706 7.875 6.125ZM10.5 6.125C10.5 5.89294 10.4078 5.67038 10.2437 5.50628C10.0796 5.34219 9.85706 5.25 9.625 5.25C9.39294 5.25 9.17038 5.34219 9.00628 5.50628C8.84219 5.67038 8.75 5.89294 8.75 6.125C8.75 6.35706 8.84219 6.57962 9.00628 6.74372C9.17038 6.90781 9.39294 7 9.625 7C9.85706 7 10.0796 6.90781 10.2437 6.74372C10.4078 6.57962 10.5 6.35706 10.5 6.125Z"
        fill="#05050D"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_24485_9287">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
